import React from 'react';
import './Spinner.css'

let Spinner=()=>{
    return (
        <div>
            <center><div className="loader">Loading...</div></center>
        </div>
    )
}

export default Spinner;